import { render } from "./GestaoDeTarefas.vue?vue&type=template&id=18e48b38"
import script from "./GestaoDeTarefas.vue?vue&type=script&lang=js"
export * from "./GestaoDeTarefas.vue?vue&type=script&lang=js"

import "./GestaoDeTarefas.vue?vue&type=style&index=0&id=18e48b38&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__